<div class="count-down-timer">
    <p>Countdown to {{ formattedDate }}</p>
    <div class="wrapper">
        <div class="description">
            <p>Days</p>
            <p>Hours</p>
            <p>Minutes</p>
            <p>Seconds</p>
        </div>
        <div class="times">
            <p #days><app-loader [loading]="true"></app-loader></p>
            <p #hours><app-loader [loading]="true"></app-loader></p>
            <p #minutes><app-loader [loading]="true"></app-loader></p>
            <p #seconds><app-loader [loading]="true"></app-loader></p>
        </div>
    </div>
</div>
